export default __webpack_public_path__ + "static/media/analyzed.2ea415fe.png";